export enum CAMPAIGN_STATUS_ENUM {
  'CREATED' = 'CREATED',
  'IN_PROGRESS' = 'IN_PROGRESS',
  'COMPLETED' = 'COMPLETED',
  'FAILED' = 'FAILED',
  'WAITING_PAY' = 'WAITING_PAY',
  'ERROR_PAY' = 'ERROR_PAY',
  'PAID' = 'PAID',
  'CANCELLED' = 'CANCELLED',
  'REVIEW' = 'REVIEW',
  'ACCEPTED' = 'ACCEPTED',
}

export const CAMPAIGN_STATUS_VALUES = Object.values(CAMPAIGN_STATUS_ENUM);

export enum CAMPAIGN_PHASES_STATUS_ENUM {
  'PENDING' = 'PENDING',
  'COMPLETED' = 'COMPLETED'
}

export const CAMPAIGN_PHASES_STATUS_VALUES = Object.values(CAMPAIGN_PHASES_STATUS_ENUM);

export enum PROMOTION_STATUS {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum CAMPAIGN_ITEM_STATUS_ENUM {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}
